<template>
  <div class="banner">
    <a href="https://sts.ac/saas-asos3" target="_blank">
      Want to win £250 ASOS vouchers?
      <img src="/images/brands/sts.png" alt="Save The Student logo" class="img-sts-logo">
    </a>
    <p><img src="/images/brands/asos.png" alt="ASOS logo" class="img-brand-logo"></p>
  </div>
</template>

<script>
export default {
  name: 'Banner'
}
</script>

<style lang="scss" scoped>

</style>
